<template>
  <div class="content">
    <div class="content-c">
      <div class="title">材料上传</div>
      <van-uploader :accept="type" v-model="fileList" :multiple="!isWX" :before-read="beforeRead"
        :after-read="afterRead" :before-delete="beforeDelete" :max-count="9" />
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant';
export default {
  name: '',
  data() {
    return {
      fileList: [
        // {
        // url: 'https://img01.yzcdn.cn/vant/leaf.jpg',
        // status: 'uploading',
        // message: '上传中...',
        // },
      ],
      realyList: [],
      id: '',
      isWX: true,
      type: '',
    };
  },
  created() {
    //
    if (this.$route.query.type == 'pic') {
      this.type = 'image/*'
    } else {
      this.type = '.doc,.pdf,.docx'
    }
    this.id = this.$route.query.id
    this.getList()
  },
  mounted() {
    //
    document.title = '应急材料上传'
    this.getDevice()
  },
  methods: {
    // 检查使用设备是苹果还是安卓
    getDevice() {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      // var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        var isWx = u.toLowerCase()
        if (isWx.indexOf('micromessenger') != -1) {
          this.isWX = true
        } else {
          this.isWX = false
        }
      } else {
        this.isWX = false
      }
    },
    //上传前置处理
    beforeRead(file) {
      // console.log('beforeRead', file);
      var judgment = true
      var arr = Array.isArray(file)
      if (this.type == 'file') {
        if (arr) {
          file.forEach(el => {
            if (el.type.includes('image') || el.type.includes('pdf')) {
              Toast('仅支持PDF格式文件');
              judgment = false
            }
          });
        } else {
          if (file.type.includes('image') || file.type.includes('pdf')) {
            Toast('仅支持PDF格式文件');
            judgment = false
          }
        }
      }
      return judgment
    },
    // 上传状态
    afterRead(file) {
      Toast.loading({
        message: '正在上传',
        forbidClick: true,
        duration: 0
      });
      // file.status = 'uploading';
      // file.message = '上传中...';
      // setTimeout(() => {
      //   file.status = 'failed';
      //   file.message = '上传失败';
      // }, 1000);
      // console.log('afterRead', file);
      const formData = new FormData();
      var arr = Array.isArray(file)
      if (arr) {
        file.forEach(el => {
          formData.append("files", el.file);
        });
      } else {
        formData.append("files", file.file);
      }
      this.$rqt.common_uploadFileBatch(formData).then(res => {
        // console.log('上传了', res);
        res.data.forEach(el => {
          var type, urls
          if (el.filePath.includes('jpg') || el.filePath.includes('jpeg') || el.filePath.includes('png')) {
            type = "image_url"
            // urls = "http://123.131.74.135:9000/yyzz"
          }
          if (el.filePath.includes('pdf')) {
            type = "pdf_url"
          }
          urls = "https://kzznzd.zwfwpt.cn/yyzz"
          this.realyList.push({
            // url: el.domain + el.filePath,
            url: urls + el.filePath,
            type,
            fileName: el.fileName
          })
        })
        Toast.clear();
        this.saveList()
        // Toast.clear()
        // Dialog({
        //   message: '请在终端点击刷新按钮',
        // });
      }).catch(err => {
        Toast.fail('上传失败');
      })
    },
    // 删除
    beforeDelete(file) {
      // console.log('beforeDelete', file);
      this.realyList.forEach((item, index) => {
        if (item.url == file.url) {
          this.realyList.splice(index, 1)
          // this.fileList.splice(index, 1)
        }
      });
      this.saveList()
    },
    // 保存上传记录
    saveList() {
      this.$rqt.common_saveRecord({
        key: this.id,
        value: this.realyList
      }).then(res => {
        this.getList()
      })
    },
    // 获取上传记录
    getList() {
      this.$rqt.common_getRecord({
        key: this.id,
      }).then(res => {
        if (res.data) {
          this.fileList = res.data
          this.realyList = res.data
        }
      })
    }
  },
};
</script>
<style scoped lang="scss">
.content {
  width: 100%;
  height: calc(100vh - 16rem);
  background-color: #fff;
}

.content-c {
  width: 90%;
  margin: auto;
  padding-top: 20px;
}

.title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}
</style>